module.exports = __webpack_public_path__ + "img/CA.b19a739b.svg";